import { useScsApi } from 'infrastructure/api';
import { useAssignmentService, AssignmentEntityType } from 'domain/shared/assignment';
import moment from 'moment';
import { DATE_FORMAT } from 'framework/utils';
import { useShowContext } from 'framework/show';
import { MapAssignmentType, ReportedHoursType } from './types';
import { generateWeeklyRawData, generateWeeklyDataFromRaw, generateProjectDataFromRaw } from './reportedHoursHelpers';

export const REPORTED_TIME_CHARTS_COLORS = [
  'var(--mui-palette-timeline-note)',
  'var(--mui-palette-warning-main)',
  'var(--mui-palette-primary-main)',
  'var(--mui-palette-success-main)',
  'var(--mui-palette-info-main)',
  'var(--mui-palette-secondary-main)',
  'var(--mui-palette-error-main)',
  'var(--mui-palette-success-light)',
  'var(--mui-palette-info-light)',
];

const useReportedHoursService = () => {
  const { data } = useShowContext();
  const { employeeAlias } = data.getData();
  const { search } = useAssignmentService();
  const { sendGetRequest } = useScsApi();

  const getAssignmentsLastTreeMothDataMethod = async () => {
    try {
      const requestReportedHours = await sendGetRequest(`/reported-hours/${employeeAlias}`);
      const reportedHours = (await requestReportedHours.json()) as ReportedHoursType[];

      const lastWeekEnd = moment().startOf('week').subtract(1, 'days').format(DATE_FORMAT.API_ONLY_DATE);
      const threeMonthsAgoWeekStart = moment().subtract(3, 'months').startOf('week').format(DATE_FORMAT.API_ONLY_DATE);

      const responceAssignments = await search({
        pageNumber: 0,
        pageSize: 30,
        sort: {
          createdAt: 'DESC',
        },
        filter: {
          'specification:assignmentsByEmployeeAlias': { eq: employeeAlias },
          from: {
            le: lastWeekEnd,
          },
          to: {
            ge: threeMonthsAgoWeekStart,
          },
        },
      });

      const mapAssignmentes: MapAssignmentType[] = (responceAssignments.result as AssignmentEntityType[]).map(
        (item: AssignmentEntityType) => {
          return {
            id: item.id,
            maxPercent: item.maxPercent,
            minPercent: item.minPercent,
            from: item.from,
            to: item.to,
            project: {
              name: item.target.displayName,
              id: item.target.id,
            },
          };
        },
      );

      const rawData = generateWeeklyRawData(mapAssignmentes, reportedHours);

      const weeklyChartData = generateWeeklyDataFromRaw(rawData);
      const projectChartData = generateProjectDataFromRaw(rawData);

      return {
        weeklyChartData,
        projectChartData,
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return {
        weeklyChartData: [],
        projectChartData: [],
      };
    }
  };

  return {
    getAssignmentsLastTreeMothDataMethod,
  };
};

export default useReportedHoursService;
